// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__zv7u_"};